import WebComponent from '../../../WebComponent.js'
import {html} from '@isceco/widget-library2/external/lit'
import QueriesColumns from '../../Queries/QueriesColumns.js'
import '@isceco/widget-library2/basic-elements/Title/Title.js'
import '@isceco/widget-library2/basic-elements/List/List.js'
import '@isceco/widget-library2/basic-elements/Filter/DateFilter.js'
import '@isceco/widget-library2/basic-elements/Filter/StringFilter.js'
import '@isceco/widget-library2/basic-elements/Filter/MultiselectFilter.js'
import '@isceco/widget-library2/basic-elements/Filter/CheckboxFilter.js'
import QueriesService from '../../../services/QueriesService.js'
import QueriesRowVariant from '../../Queries/QueriesRowVariant.js'
import ModuleEnum from '../../../enum/ModuleEnum.js'
import QueriesListService from '../../Queries/QueriesListService.js'
import TypeEnum from '../../../enum/TypeEnum.js'
import OkEnum from '../../../enum/AnfrageStatusEnum.js'
import ErrorUtil from '../../../services/ErrorUtil.js'
import VerarbeitungStatusEnum from '../../../enum/VerarbeitungStatusEnum.js'
import CommentCell from '../../Queries/CommentCell.js'
import TransportModusEnum from '../../../enum/TransportModusEnum.js'

export default class EDAV extends WebComponent {
  get translationFile() {
    return './views/EDAV/Queries/i18n.json'
  }

  connectedCallback() {
    super.connectedCallback()
    this.module = [ModuleEnum.ADDITIONAL_KEYS.EDAV, ModuleEnum.KEYS.EDAV_INPEC, ModuleEnum.KEYS.EDAV_TRACES, ModuleEnum.KEYS.EDAV_WHITELIST]
    this.reload()
  }

  reload() {
    const queriesService = new QueriesService()

    Promise.all([
      queriesService.getBackendListUrl(),
      queriesService.listByModule('responseerrors', this.module)
    ])
      .then(([url, errors]) => {
        this.listUrl = url
        this.errors = ErrorUtil.ITEMS(errors)
        this.render()
      })
  }

  getTemplate() {
    return html`
      <isceco-title text="${this.i18n.translate('page.title')}"></isceco-title>

      <isceco-filter-group>
        <isceco-date-filter
          label="${this.i18n.translate('table.header.time')}"
          key="time">
        </isceco-date-filter>
        <isceco-string-filter
          label="${this.i18n.translate('table.header.referenceNumber')}"
          key="referenceNumber"
          minchars="2">
        </isceco-string-filter>
        <isceco-string-filter
          label="${this.i18n.translate('table.header.usageId')}"
          key="usageId"
          minchars="2">
        </isceco-string-filter>
        <isceco-string-filter
          label="${this.i18n.translate('table.header.permitId')}"
          key="permitId"
          minchars="2">
        </isceco-string-filter>
        <isceco-string-filter
          label="${this.i18n.translate('table.header.nctNumber')}"
          key="nctNumber"
          minchars="2">
        </isceco-string-filter>
        <isceco-string-filter
          label="${this.i18n.translate('table.header.controlCode')}"
          key="controlCode"
          minchars="2">
        </isceco-string-filter>
        <isceco-multiselect-filter
          .items="${TransportModusEnum.ITEMS()}"
          label="${this.i18n.translate('table.header.modeOfTransport')}"
          key="modeOfTransport">
        </isceco-multiselect-filter>
        <isceco-multiselect-filter
          .items="${TypeEnum.ITEMS()}"
          label="${this.i18n.translate('table.header.type')}"
          key="type">
        </isceco-multiselect-filter>
        <isceco-multiselect-filter
          .items="${OkEnum.ITEMS()}"
          label="${this.i18n.translate('table.header.anfrageStatus')}"
          key="ok">
        </isceco-multiselect-filter>
        <isceco-multiselect-filter
          .items="${VerarbeitungStatusEnum.ITEMS()}"
          label="${this.i18n.translate('table.header.status')}"
          key="status">
        </isceco-multiselect-filter>
        <isceco-multiselect-filter
          .items="${this.errors}"
          label="${this.i18n.translate('table.header.errors')}"
          key="errors">
        </isceco-multiselect-filter>
        <isceco-multiselect-filter
          .items="${ModuleEnum.EDAV_ITEMS()}"
          label="${this.i18n.translate('table.header.module')}"
          key="module">
        </isceco-multiselect-filter>
        <isceco-checkbox-filter
          label="${this.i18n.translate('table.header.processed')}"
          key="processed">
        </isceco-checkbox-filter>
        <isceco-checkbox-filter
          label="${this.i18n.translate('table.header.comment')}"
          key="comment">
        </isceco-checkbox-filter>
      </isceco-filter-group>

      <isceco-list id="queries-table"
                   update-event="${QueriesColumns.UPDATE_TABLE}"
                   .i18n="${this.i18n}"
                   .columns="${QueriesColumns.getEDAVColumns()}"
                   .rowVariant="${new QueriesRowVariant()}"
                   .rowurl="${this._toDetail}"
                   .listService="${new QueriesListService(this.listUrl, this.module, [300, 301])}"
                   sort="time"
      ></isceco-list>

      ${CommentCell.renderDialog(this.i18n)}
    `
  }

  _toDetail = dto => `EDAVDetail/${dto.id}`
}

customElements.define('management-frontend-edav-queries', EDAV)
